import React from 'react';
import { CreditCard, Shield, IdCard, HardHat, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const Benefits = () => {
  const { t } = useLanguage();

  const benefits = [
    {
      icon: CreditCard,
      color: 'text-green-600',
      bgColor: 'bg-green-100',
      ...t.benefits.payment
    },
    {
      icon: Shield,
      color: 'text-blue-600',
      bgColor: 'bg-blue-100',
      ...t.benefits.insurance
    },
    {
      icon: IdCard,
      color: 'text-purple-600',
      bgColor: 'bg-purple-100',
      ...t.benefits.deposit
    },
    {
      icon: HardHat,
      color: 'text-orange-600',
      bgColor: 'bg-orange-100',
      ...t.benefits.helmets
    },
    {
      icon: MapPin,
      color: 'text-red-600',
      bgColor: 'bg-red-100',
      ...t.benefits.gps
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.benefits.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t.benefits.subtitle}
          </p>
        </div>

        {/* Benefits Grid - Mobile optimized: 1 column on mobile, 2 on tablet, 5 on desktop */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6 max-w-7xl mx-auto px-4">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <Card 
                key={index}
                className="text-center hover:shadow-2xl transition-all duration-300 hover:scale-105 border-2 border-gray-200"
              >
                <CardHeader className="pb-3">
                  <div className="flex justify-center mb-3">
                    <div className={`${benefit.bgColor} p-3 rounded-full`}>
                      <Icon className={`w-7 h-7 ${benefit.color}`} />
                    </div>
                  </div>
                  <CardTitle className="text-base md:text-lg font-bold text-gray-900">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                  <CardDescription className="text-gray-600 text-xs md:text-sm leading-relaxed">
                    {benefit.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
